import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DateService } from 'src/app/services/date.service';

@Component({
  selector: 'app-warranty-input',
  templateUrl: './warranty-input.component.html',
  styleUrls: ['./warranty-input.component.css']
})
export class WarrantyInputComponent implements OnInit {
  warrantyActive;
  warrantyProgress;
  warrantyCurrent;
  warrantyEnd;
  today = new Date();

  @Input() warranty: Date;
  @Input() warrantyLastUpdate: Date;
  @Input() createdAt: Date;
  @Input() flex = 'column';
  @Output() emitWarrantyValues = new EventEmitter<Date>();

  constructor(
    public dateService: DateService,
  ) { }

  ngOnInit(): void {
  }

  // Função par auxiliar na criação da barra de progresso de garantia
  progressWarranty(warranty): void {
    if (warranty) {
      const now = new Date();
      this.warrantyEnd = this.dateService.getRelativeTime(
        warranty,
        this.createdAt ?? now,
      );
      this.warrantyCurrent = this.dateService.getRelativeTime(warranty, now);

      if (this.warrantyEnd[0] || this.warrantyCurrent[0]) {
        this.warrantyProgress = this.warrantyCurrent[0] / this.warrantyEnd[0];
      } else {
        this.warrantyProgress = 0;
      }

      if (this.warrantyProgress <= 0) {
        // Sem garantia
        this.warrantyActive = 3;
      } else {
        if (this.dateService.isWithinEndOfWarranty(this.warrantyCurrent)) {
          // Dentro da janela "fim de garantia" da organização
          this.warrantyActive = 2;
        } else {
          this.warrantyActive = 1;
        }
      }
    } else {
      this.warrantyActive = undefined;
      this.warrantyProgress = undefined;
    }
    this.emitWarrantyValues.emit(warranty);
  }
}
